import { Box } from '@hivebrite/design-system/Box';
import { Divider } from '@hivebrite/design-system/Divider';

import type { SliderItemAttributes } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/types';
import DisplayFieldOption from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayFieldOption';
import SelectSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/SelectSetting';
import TextSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/TextSetting';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import {
  CONTENT_TYPES_USER_LANE_OPTIONS,
  USER_LANE_SUBLINE_OPTIONS,
} from 'hb-builder/utils/dynamicSelectorsHelpers';

const UsersContent = ({
  item,
  onChange,
}: Pick<ComponentSettingsTab<SliderItemAttributes>, 'item' | 'onChange'>) => {
  const { dynamicAttributes } = item.attributes || {};
  const { secondSubline } = dynamicAttributes || {};

  return (
    <AccordionTitle key={item.id} title={__('Content settings')}>
      <SelectSetting
        item={item}
        onChange={onChange}
        options={CONTENT_TYPES_USER_LANE_OPTIONS}
        settingKey="dynamicAttributes.query.dataUserType"
        title={s__('Builder|Choose a type of users')}
      />
      <Divider mb={5} mt={1} />
      <InputTitle label={__('Text')} boxProps={{ mb: 4 }} />
      <InputTitle label={__('Lane name')} boxProps={{ mb: 2 }} />
      <TextSetting
        item={item}
        maxLength={100}
        onChange={onChange}
        settingKey="attributes.dynamicAttributes.title"
        width="100%"
      />
      <DisplayFieldOption
        onChange={onChange}
        item={item}
        label={s__('Builder|Display subline')}
        keySetter="attributes.dynamicAttributes.firstSubline.display"
      />
      <Box mb={2} />
      <SelectSetting
        item={item}
        onChange={onChange}
        options={USER_LANE_SUBLINE_OPTIONS}
        settingKey="dynamicAttributes.firstSubline.type"
        title={s__('Builder|Choose a type of subline')}
      />
      <DisplayFieldOption
        onChange={onChange}
        item={item}
        label={__('Display second subline')}
        keySetter="attributes.dynamicAttributes.secondSubline.display"
      />
      <Box mb={2} />
      {secondSubline?.display && (
        <SelectSetting
          item={item}
          onChange={onChange}
          options={USER_LANE_SUBLINE_OPTIONS}
          settingKey="dynamicAttributes.secondSubline.type"
          title={s__('Builder|Choose a type of subline')}
        />
      )}
    </AccordionTitle>
  );
};

export default UsersContent;
